import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import LayoutReducer from "./LayoutReducer";

export default combineReducers({
    authentication: AuthReducer,
    layout: LayoutReducer,
})